import React from 'react';

import { LazyConfigurationPage } from '@confluence/site-settings/entry-points/ConfigurationPage.ts';
import { ADMIN_CONFIGURATION_ANALYTICS_SOURCE } from '@confluence/site-settings/entry-points/configurationConstants.ts';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';

export const AdminConfigurationRoute: {
	(): React.JSX.Element;
	NAVIGATION_PARAMS(): {
		Screen: {
			screenEvent: {
				name: string;
			};
		};
		MainLayout: {
			navView: string;
		};
	};
} = (): React.JSX.Element => <LazyConfigurationPage />;

AdminConfigurationRoute.NAVIGATION_PARAMS = (): {
	Screen: {
		screenEvent: {
			name: string;
		};
	};
	MainLayout: {
		navView: string;
	};
} => ({
	Screen: {
		screenEvent: { name: ADMIN_CONFIGURATION_ANALYTICS_SOURCE },
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
